window.Account = {
    hosts: null,
    accountLinkId: 'accountLink',
    loginLinkId: 'account-login-link',
    signupLinkId: 'account-signup-link',
    shopUrl: 'products/',
    loginLink: null,
    sessionCookie: 'access-token',
    sessionHashCookie: 'sh',
    loginCookie: 'lg',
    logoutFormId: 'ni-account-logout-action',
    accountId: 'accountSnippet',
    accountSnippet: '',
    storageKey: 'us',
    interval: null,
    redirectAfterLogin: null,
    currentAccountHeight: 200,
    currentAccountWidth: 720,
    basketCounter: 0,

    // This sets up a promise for the login state and listens for an event
    // sent from the login bundle to resolve it
    loginState: (function() {
        var deferred = jQuery.Deferred();

        function resolve() {
            window.emitter.off('login-state', resolve);
            deferred.resolve();
        }

        if (window.loginStateResolved)  {
          deferred.resolve();
        } else {
          window.emitter.on('login-state', resolve);
        }

        return deferred.promise();
    })(),

    hosts: (function() {
        // setup
        var domainParts = window.location.hostname.split('.');
        domainParts.shift();
        var domain = domainParts.join('.');

        return {
            'website': window.location.protocol + '//www.' + domain,
            'websiteSSL': 'https://www.' + domain,
            'shop': window.location.protocol + '//shop.' + domain,
            'shopSSL': 'https://shop.' + domain
        };

    })(),

    init: function() {
        // basket & shop issues
        this.basketCounter = Util.getBasketCount();
        this.setBasketCountTo(this.basketCounter);
    },

    /**
     * Opens Login or Account Popop
     */
    open: function (redirect) {


        window.emitter.emit('open-login-modal', { url: redirect });
    },

    // is called after login / logout to update the page
    afterLogin: function () {
        // clear interval
        window.clearInterval(Account.interval);
        // refresh page
        if (Account.redirectAfterLogin) {
            if (Util.isNiUrl(Account.redirectAfterLogin)) {
                window.location.href = Account.redirectAfterLogin;
                return;
            }
        }
    },

    // returns if a user is logged in
    isLoggedIn: function () {
        return Util.getCookie(Account.loginCookie) !== null;
    },

    isValidSession: function() {
        return Util.getCookie(Account.sessionHashCookie) !== null;
    },

    isPermanentLogin: function () {
        if (this.isValidSession()) {
            return Util.getCookie(this.sessionHashCookie).split('|')[2] === '1';
        }
    },

    // Get authentication state for tracking
    getAuthState: function () {
        var authStates = {
            not_logged_in: 'Anonymous',
            logged_in: 'Logged in',
            remembered_logged_in: 'Remembered'
        };

        return Account.isLoggedIn()
            ? authStates.logged_in
            : Account.isPermanentLogin()
                ? authStates.remembered_logged_in
                : authStates.not_logged_in;
    },

    // handles logout
    logout: function () {
        var action = '';
        if (Account.isShopPage()) {
            window.emitter.emit('logout');
        } else {
            jQuery('body').addClass('wait');
            window.emitter.emit('logout');
        }
    },

    // set basket count
    setBasketCountTo: function (count) {
        if (Util.isNumber(count)) {
            if (jQuery('#basketLink-legacy').length > 0) {
                jQuery('#cartAmount').text(count);
            }
            jQuery('#cartAmount').toggle(count > 0);
            Account.basketCounter = count;
        }
    },

    recalculateSessionHash: function () {
        var ttl = 60,
            sh = Util.getCookie(Account.sessionHashCookie);

        if (!sh) {
            Util.log('ACCOUNT: Session hash not found. User is logged out');
            return false;
        }

        Util.log('ACCOUNT: Session hash found: ', sh);

        if (Account.isLoggedIn() && Account.isValidSession()) {
            Util.log('ACCOUNT: User is logged in and has valid session cookie.');

            var parts = sh.split("|"),
                now = Math.floor(Date.now() / 1000);

            if ((now - parseInt(parts[0], 10)) > ttl) {
                parts[0] = now;
                sh = parts.join('|');
                Util.log('ACCOUNT: User data has timed out and a session is available. Session Hash timestamp updated: ', sh);
            }
        }

        return sh;
    },

    storeUserData: function(data) {
        return Util.setStorageItem(this.storageKey, data, {merge: true, userScope: true, permanent: this.isPermanentLogin()})
    },

    getUserData: Util.cachePromise(function() {
        return jQuery
            // Wait for a valid login state from the login bundle
            .when(Account.loginState)
            .then(function() {
                var sh = Account.recalculateSessionHash();

                // If there is a session hash this means we are logged in or at least were logged in
                if (sh) {
                    return jQuery.ajax({
                        type: 'GET',
                        data: {
                            eID: 'user',
                            ao: 'Account',
                            sh: sh
                        },
                        dataType: 'jsonp',
                        cache : true,
                        jsonpCallback : 'getUserDataCb',
                        url: Account.hosts['website']
                    });
                }
            })
            .then(function(data) {
                if (!data || !data.loggedIn) {
                    // Remove any possibly existing session cookie
                    Util.removeCookie(Account.loginCookie);
                    Util.removeCookie(Account.sessionHashCookie);
                    Util.log('ACCOUNT: User not logged in. Cookies cleaned.');
                    return null;
                }
                return data;
            });
    }),

    // listener used for auto update page and iframe height. Can't do this from different server's SSL iframe
    accountListener: function () {
        if (typeof myLytebox !== 'undefined') {
            var height = Util.getCookie('accountHeight');
            if (Util.isNumber(height)) {
                if (height !== Account.currentAccountHeight) {
                    myLytebox.adjustHeight(height);
                    Account.currentAccountHeight = height;
                }
            }
        }
        if (Account.isLoggedIn()) {
            Account.updatePage();
        }
        //console.log('listen');
    },

    // register redirect url after login
    registerRedirectAfterLogin: function (url) {
        Account.redirectAfterLogin = url ? url : null;
    },

    // returns if page is shop page
    isShopPage: function () {
        return (Util.getProtocol() + '//' + window.location.hostname === Account.hosts['shop']);
    },

    // go to login page
    goToLoginPage: function () {
        if (Account.isShopPage()) {
            Util.goToUrl(Account.hosts['website'] + '/' + Util.getLang() + '/login/?redirect=' + encodeURIComponent(window.location.href));
        } else {
            Util.goToUrl('/' + Util.getLang() + '/login/?redirect=' + encodeURIComponent(window.location.search + window.location.pathname));
        }
    },
};

jQuery(function () {
    Account.init();
    // prevent ie users from cross protocol conflict
    if (Util.isLessThanIE10()) {
        jQuery('#' + Account.loginLinkId).attr('data-toggle', null);
    }

    jQuery(document).on('click', '.login-link', function(e) {
        Account.open(location.href);
    });

});

